import axios from '../../apis/apicidtech';
import { types } from '../../types/types';
import { getToken } from '../../utils/tokencidtechapi';
import { dispatchpending, dispatchresponse, dispatchresponseerror } from '../utils/dispatches';

export const  novoatualiza = (dados) => {
  return async dispatch => {

    dispatchpending(dispatch);
    
    try {
      const response = await axios.put('promotoras/eventos/novoatualiza',
      {
        ...dados
      }
      ,
      {
        headers: {
          Accept: 'application/json',
          Authorization: `Bearer ${getToken()}`
        }
      }
      );

      dispatchresponse(dispatch, response.data, types.EVENTO.CADASTRADO);
      
    } catch (error) {
      dispatchresponseerror(dispatch, error);
    }
  }
}

export const eventos = (filtro = {}) => {

  return async dispatch => {

    dispatchpending(dispatch);
    
    try {
      const response = await axios.get('promotoras/eventos/dados/idevento',
        {
          headers: {
            Accept: 'application/json',
            Authorization: `Bearer ${getToken()}`
          },
          params: {
            ...filtro
          }
        }
      );

      dispatchresponse(dispatch, response.data, types.EVENTO.DADOSEVENTO);
      return response.data?response.data[0]:{};
    } catch (error) {
      dispatchresponseerror(dispatch, error);
    }
  }
}

export const eventodadosweb = (filtro = {}) => {

  return async dispatch => {

    dispatchpending(dispatch);
    
    try {
      const response = await axios.get('promotoras/eventos/dados/web',
        {
          headers: {
            Accept: 'application/json',
            Authorization: `Bearer ${getToken()}`
          },
          params: {
            ...filtro
          }
        }
      );

      dispatchresponse(dispatch, response.data, types.EVENTO.DADOSWEBEVENTO);
      return response.data?response.data[0]:{};
    } catch (error) {
      dispatchresponseerror(dispatch, error);
    }
  }
}

export const pesquisa = (filtro = {}) => {

  return async dispatch => {

    dispatchpending(dispatch);
    
    try {
      console.log(filtro);
      const response = await axios.get('promotoras/eventos/pesquisa',
        {
          headers: {
            Accept: 'application/json',
            Authorization: `Bearer ${getToken()}`
          },
          params: {
            ...filtro
          }
        }
      );

      dispatchresponse(dispatch, response.data, types.EVENTO.PESQUISADADOSEVENTO);
        return response.data;
    } catch (error) {
      console.log(error);
      dispatchresponseerror(dispatch, error);
    }
  }
}

export const eventoselecionado = (evento = {}) => {
  return dispatch => {
    dispatch({
      type: types.EVENTO.EVENTOSELECTED,
      payload: evento
    })
  }
}

export const enviafaleconosco = (filtro = {}) => {

  return async dispatch => {

    dispatchpending(dispatch);
    
    try {      
      const response = await axios.get('helpers/email/envia/faleconosco',
        {
          headers: {
            Accept: 'application/json',
            Authorization: `Bearer ${getToken()}`
          },
          params: {
            ...filtro
          }
        }
      );

      dispatchresponse(dispatch, response.data, types.EVENTO.FALECONOSCO);
        return response.data;
    } catch (error) {
      console.log(error);
      dispatchresponseerror(dispatch, error);
    }
  }
}